var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAttachment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.391 12.4327L11.45 19.2929C9.64629 21.0849 7.21929 20.9076 5.67054 19.3582C4.11235 17.8275 3.93292 15.4474 5.73665 13.6554L15.2086 4.30311C16.2946 3.22974 17.8905 3.08041 18.9293 4.09777C19.9587 5.1338 19.8076 6.70185 18.731 7.77521L9.47631 16.9221C9.01357 17.3982 8.44696 17.2582 8.12587 16.9408C7.80479 16.6141 7.67258 16.0728 8.13532 15.5968L14.6042 9.22192C14.8875 8.93258 14.9064 8.5219 14.6325 8.25123C14.3586 7.98988 13.9431 8.00855 13.6598 8.28856L7.17207 14.7008C6.20883 15.6528 6.2466 17.1088 7.09652 17.9488C8.02199 18.8635 9.41964 18.8449 10.3923 17.8835L19.6848 8.69924C21.4508 6.95385 21.3752 4.65779 19.8359 3.13641C18.3344 1.65236 15.9735 1.54036 14.2075 3.28575L4.68841 12.7034C2.35584 15.0088 2.53527 18.3035 4.64119 20.3849C6.74711 22.457 10.0807 22.6343 12.4133 20.3383L19.4015 13.4314C19.6754 13.1607 19.6754 12.666 19.3921 12.414C19.1182 12.1247 18.6744 12.162 18.391 12.4327Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-attachment.1842e514e5734f0cfec7ff4386c5f6ab.svg";